export default __webpack_public_path__ + "static/media/fallback.5ddd7574.png";